import { render, staticRenderFns } from "./TeacherOfficeViewer.vue?vue&type=template&id=76544303&scoped=true"
import script from "./TeacherOfficeViewer.vue?vue&type=script&lang=js"
export * from "./TeacherOfficeViewer.vue?vue&type=script&lang=js"
import style0 from "./TeacherOfficeViewer.vue?vue&type=style&index=0&id=76544303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76544303",
  null
  
)

export default component.exports